const luxSidebar = {
    /**
     * Bind tab-switching on all `.lux-sidebar` elements.
     *
     * @returns {void}
     */
    init() {
        const luxSidebarElements = document.querySelectorAll(".lux-sidebar");

        luxSidebarElements.forEach(function (sidebar) {
            const luxContents = sidebar.querySelectorAll(
                ".lux-sidebar-content",
            );
            const luxNavToggle = sidebar.querySelector(
                ".lux-sidebar-nav-toggle",
            );
            const luxToggles = sidebar.querySelectorAll(
                ".lux-sidebar-tab[data-toggle='lux-sidebar']",
            );

            luxToggles.forEach(function (toggle) {
                const dataTarget = toggle.getAttribute("data-target");

                if (!dataTarget) return;

                const target = document.getElementById(dataTarget);

                toggle.addEventListener("click", function () {
                    const header = document.querySelector("header");
                    const headerHeight = header ? header.offsetHeight : 0;
                    const sidebarTop =
                        sidebar.getBoundingClientRect().top + window.scrollY;

                    const scrollTarget = sidebarTop - headerHeight - 48;

                    luxContents.forEach(function (content) {
                        content.classList.remove("active");
                    });

                    luxToggles.forEach(function (tab) {
                        tab.classList.remove("active");
                    });

                    toggle.classList.add("active");

                    if (target) {
                        target.classList.add("active");
                    }

                    sidebar.classList.remove("active");

                    window.scrollTo({
                        top: scrollTarget,
                        behavior: "smooth",
                    });
                });
            });

            if (luxNavToggle) {
                luxNavToggle.addEventListener("click", function () {
                    sidebar.classList.toggle("active");
                });
            }
        });
    },
};

window.luxSidebar = luxSidebar;
